import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import type { ErrorSummaryItem } from './useFormErrorSummary';
import styles from './ErrorSummary.module.scss';

interface ErrorSummaryProps {
  items: ErrorSummaryItem[];
  /** Własny nagłówek (np. „Nie zapisano dostawcy” po błędzie serwera); domyślnie liczba błędów formularza. */
  title?: string;
}

/** Lista błędów formularza z linkami do pól; po nieudanym zapisie dostaje fokus (tabIndex -1). */
const ErrorSummary = forwardRef<HTMLDivElement, ErrorSummaryProps>(({ items, title }, ref) => {
  const { t } = useTranslation('common');

  if (items.length === 0) return null;

  const focusField = (event: React.MouseEvent, item: ErrorSummaryItem) => {
    event.preventDefault();
    if (item.onSelect) item.onSelect();
    else document.getElementById(item.fieldId)?.focus();
  };

  return (
    <div ref={ref} className={styles.summary} role="alert" tabIndex={-1}>
      <strong>{title ?? t('common:ui.errorSummary', { count: items.length })}</strong>
      <ul className={styles.list}>
        {items.map((item) => (
          // Kilka spraw może wskazywać to samo pole (np. brak okresu dla dwóch grup przy jednej dacie).
          <li key={`${item.fieldId}:${item.message}`}>
            <a href={`#${item.fieldId}`} onClick={(event) => focusField(event, item)}>
              {item.message}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
});

ErrorSummary.displayName = 'ErrorSummary';

export default ErrorSummary;
